<template>
    <div>
        <!-- Dialog Begin -->
        <el-dialog
            :title="$t('entities.player.importPlayers')"
            :visible.sync="dialogTableVisible"
            :before-close="handleClose"
            v-loading.fullscreen="loading"
        >
            <!-- Begin Row -->
            <el-row :gutter="20">
                <!-- Left -->
                <el-col :span="12">
                    <div class="grid-content bg-purple"></div>
                    <h3 class="page-title">{{$t('entities.team.singular')}}</h3>
                    <el-form
                        :class="{ show: true, 'show-mobile': isMobile }"
                        v-on:submit.native.prevent
                    >
                        <el-form-item :label="$t('entities.team.prop.name')">{{ team.name }}</el-form-item>

                        <el-form-item
                            :label="$t('entities.team.prop.category')"
                        >{{ team.category.label }}</el-form-item>
                    </el-form>
                </el-col>
                <!-- Right -->
                <el-col :span="12">
                    <upload-excel-component
                        :on-success="handleSuccess"
                        :before-upload="beforeUpload"
                    />
                </el-col>
            </el-row>
            <!-- End row -->
            <!-- Table BEGIN -->
            <template>
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    border
                    highlight-current-row
                    style="width: 100%;margin-top:20px;"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection" width="55"></el-table-column>
<!-- <el-table-column
                        prop="namePublic"
                        :label="$t('entities.player.prop.namePublic')"
                        sortable="custom"
                    ></el-table-column> -->
                    <el-table-column
                        prop="name"
                        :label="$t('entities.player.prop.name')"
                        sortable="custom"
                    ></el-table-column>
                    <el-table-column
                        prop="lastName"
                        :label="$t('entities.player.prop.lastName')"
                        sortable="custom"
                    ></el-table-column>
                    <el-table-column
                        prop="dni"
                        :label="$t('entities.player.prop.dni')"
                        sortable="custom"
                    ></el-table-column>
                    <el-table-column
                        prop="birthdate"
                        :label="$t('entities.player.prop.birthdate')"
                        sortable="custom"
                    >
                        <template slot-scope="scope">{{ getDateFormat(scope.row.birthdate) }}</template>
                    </el-table-column>
                    <el-table-column
                        prop="dorsal"
                        :label="$t('entities.player.prop.dorsal')"
                        sortable="custom"
                    ></el-table-column>
                    <!-- <el-table-column
                        prop="email"
                        :label="$t('entities.player.prop.email')"
                        sortable="custom"
                    ></el-table-column> -->
                    <!-- <el-table-column
                        v-for="item of tableHeader"
                        :prop="item"
                        :label="item"
                        :key="item"
                    ></el-table-column>-->
                </el-table>
                <div style="margin-top: 20px">
                    <el-button
                        @click="save()"
                        :disabled="loading || playersSelected.length === 0"
                        type="primary"
                        icon="el-icon-fa-floppy-o"
                    >Guardar</el-button>
                    <el-button @click="toggleSelection()">Clear selection</el-button>
                </div>
            </template>
            <!-- Table END -->
        </el-dialog>
        <!-- Dialog END -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import UploadExcelComponent from "@/components/UploadExcel";
import _ from "underscore";
import Cookies from "js-cookie"; // birthdate

/* eslint-disable */
import moment from "moment"; // birthdate

export default {
    name: "app-club-list",
    components: { UploadExcelComponent },

    data() {
        return {
            dialogTableVisible: true,
            tableData: [],
            tableHeader: [],
            playersSelected: []
        };
    },

    computed: {
        ...mapGetters({
            loading: "entities/player/import/loading",
            list: "entities/player/import/list",
            team: "entities/player/import/team",
            isMobile: "shared/isMobile"
        })
    },

    // created() {
    //     this.$store.dispatch(
    //     'entities/club/historyFull/setup'
    //     );
    // },

    // beforeRouteLeave(to, from, next) {
    //     this.$store.dispatch(
    //     'entities/club/historyFull/clear',
    //     );
    //     next();
    // },

    created() {
        this.dialogTableVisible = true;
    },

    beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/player/import/clear");
        next();
    },
    methods: {
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },

        handleSelectionChange(val) {
            this.playersSelected = val;
        },

        save() {
            // players
            var playerLsit = [];

            _.forEach(this.playersSelected, (value, index, array) => {
                var playerToSave = {
                    namePublic: value.namePublic,
                    name: value.name,
                    lastName: value.lastName,
                    dni: value.dni,
                    birthdate: moment(value.birthdate).format("YYYY-MM-DD"),
                    dorsal: value.dorsal,
                    email: value.email,
                    team: this.team,
                    picture: {
                        name: "",
                        size: 0
                    }
                };

                playerLsit.push(playerToSave);
            });
            console.log("<---- SAVE ");

            console.log(playerLsit);

            this.$store
                .dispatch("entities/player/import/createAllPlayers", playerLsit)
                .then(() => {
                    this.$router.go(-1);
                });
        },

        handleClose(done) {
            this.$confirm(this.$t("confirm.areYouSureCloseDialog"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: "warning"
            })
                .then(_ => {
                    done();
                    this.$router.go(-1);
                })
                .catch(_ => {});
        },
        // Functions upload excel
        beforeUpload(file) {
            const isLt1M = file.size / 1024 / 1024 < 1;

            if (isLt1M) {
                return true;
            }

            this.$message({
                message: "Please do not upload files larger than 1m in size.",
                type: "warning"
            });
            return false;
        },
        handleSuccess({ results, header }) {
            this.tableData = [];
            results.forEach(value => {
                var model = {
                    namePublic: value.namePublic ? value.namePublic : "",
                    name: value.name ? value.name : "",
                    lastName: value.lastName ? value.lastName : "",
                    dni: value.dni ? value.dni : "",
                    birthdate: value.birthdate
                        ? moment(value.birthdate).format("YYYY-MM-DD")
                        : "",
                    dorsal: value.dorsal ? value.dorsal : "",
                    email: value.email ? value.email : ""
                };

          
                var name = "";
                var lastName = "";
                var namePublic = "";
                var stringList;
                var nameLastName = value.nameLastName ? value.nameLastName : "";

                stringList = nameLastName.split(",");
      console.log("VALUE");
                console.log(stringList.length);

                if (stringList.length >= 1) {
                    if (stringList.length == 1) {
                        model.name = nameLastName;
                    } else {
                        model.name = stringList[0];
                        model.lastName = stringList[1];
                    }
                    model.namePublic = model.name;
                }

                this.tableData.push(model);
            });
            this.tableHeader = header;
        },

        getDateFormat(dateString) {
            console.log("<---- GET DATE FORMAT");
            console.log(dateString);
            console.log(new Date(dateString));

            return moment(dateString, ["YYYY-MM-DD"])
                .locale(Cookies.get("language") || "es")
                .format("L");
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/player/player-import/player-import.vue?76c53051